import styled from 'styled-components';

export const StyledSectionHideButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: fit-content;
  box-shadow: ${(props) => props.theme.shadow.default};
  border-radius: 12px;
  padding: 15px 0;

  transition: all 0.2s ease-in-out;

  > aside {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 24px;
    width: 100%;
    height: 100%;
    min-height: 60px;
    max-height: 80px;
    cursor: pointer;

    border-radius: 12px;

    p {
      font-size: 18px;
      font-weight: 700;
      color: ${(props) => props.theme.colors.gray[600]};
    }
    svg {
      color: ${(props) => props.theme.colors.orange.primary};
      height: 36px;
      width: 36px;
    }
  }
`;
